import { useState } from "react";
import { RelatoriosLayout } from "../../../layouts";
import { responseErros } from "../../../utils";
import {
  FormFiltroAvancadoAnaliseAbcClientes,
  FormFiltroAvancadoAniversario,
} from "./components";
import { notification, PessoaService } from "../../../services";
import { PrintAniversario } from "../layouts";
import { PermisoesHelper, responseStreamHelper } from "../../../helpers";
const pessoasService = new PessoaService();

const RelatoriosIntegracao = () => {
  const permissoesHelper = new PermisoesHelper();
  const [loading, setLoading] = useState(false);
  const [filtrosAvancados, setFiltrosAvancados] = useState({});
  const [filtrosAplicadosImpressao, setFiltrosAplicadosImpressao] = useState(
    {},
  );

  const subgruposRelatoriosIntegracao = [
    {
      subgrupo: "Pessoas",
      propriedades: [
        {
          name: "701 - Análise ABC Clientes",
          // layoutImpressao: PrintAniversario,
          permissao: permissoesHelper.temPermisao(
            "relatorio-analise-abc-clientes",
          ),
          funcaoBuscarDadosRelatorio: buscarAnaliseAbcClientes,
          formulario: FormFiltroAvancadoAnaliseAbcClientes,
        },
        {
          name: "702 - Aniversarios",
          layoutImpressao: PrintAniversario,
          permissao: permissoesHelper.temPermisao(
            "relatorio-pessoas-aniversario",
          ),
          funcaoBuscarDadosRelatorio: buscarAniversarioPessoas,
          formulario: FormFiltroAvancadoAniversario,
        },
      ],
    },
  ];

  async function buscarAniversarioPessoas(filtros) {
    setLoading(true);
    try {
      const result = await pessoasService.relatorioAniversario({
        ...filtros,
        resumido: true,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarAnaliseAbcClientes(filtros) {
    setLoading(true);
    try {
      const result = await pessoasService.relatorioAnaliseAbcClientes({
        ...filtros,
        resumido: true,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function openAbaRelatorio(blob) {
    try {
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  return (
    <RelatoriosLayout
      title="Relatório de Cadastros"
      subgruposRelatorios={subgruposRelatoriosIntegracao}
      filtrosAplicadosImpressao={filtrosAplicadosImpressao}
      dadosRelatorioResumido={{}}
      setFiltrosAplicadosImpressao={setFiltrosAplicadosImpressao}
      filtrosAvancados={filtrosAvancados}
      setFiltrosAvancados={setFiltrosAvancados}
      loading={loading}
    />
  );
};

export default RelatoriosIntegracao;
